import ky from 'ky';
import * as Sentry from '@sentry/react';

import { fetchAuthSession } from 'aws-amplify/auth';

function baseurl() {
  switch (import.meta.env.VITE_APP_ENV) {
    case 'prod':
      return 'https://api.tailor.wf/';
    case 'test':
    case 'arne':
      return 'https://apitest.tailor.wf/';
    case 'go-dev':
      return 'https://tailor-api.go-dev.entail.io/';
    case 'go-prod':
      return 'https://tailor-api.go.entail.io/';
    case 'dev':
    case 'localhost-go-dev':
      return 'http://localhost:8000/';
    default:
      throw new TypeError('Unknown value for env,' + import.meta.env.VITE_APP_ENV);
  }
}

const original = ky.create({
  prefix: baseurl(),
});

const extended = original.extend({
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        try {
          const session = await fetchAuthSession();
          const token = session.tokens?.accessToken?.toString();
          if (token) {
            request.headers.set('Authorization', `Bearer ${token}`);
          }
        } catch (error) {
          if (error instanceof Error && error.name !== 'UserUnAuthenticatedException') {
            Sentry.captureException(error);
          }
        }
      },
    ],
  },
});

export default extended;
